import React from 'react';
import cn from 'classnames';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

import {INavigationItemProps} from '../../IFlatNavigationItem';

import FlatNavigationLink from './Subcomponents';

const FlatNavigationItemContent = (props: INavigationItemProps) => {
	const {
		description,
		url,
		title,
		color,
		template,
		isActive,
		children,
		navigationParams,
		queryParameters,
		hasSubLists,
		hasHiddenChildren,
		image,
		customSettings,
	} = props;

	if (!title) {
		return null;
	}

	const isEditorialItem = customSettings?.showImage && image;

	return (
		<li
			className={cn({
				'has-sub-list': !!children || hasHiddenChildren,
				'has-multi-sub-lists': !template && !!hasSubLists,
				active: isActive,
				editorial: isEditorialItem,
			})}
		>
			{(!!children || hasHiddenChildren)
			&& typeof props.handleNavigationItemClick === 'function'
				?
				<Button onClick={props.handleNavigationItemClick} classNames="navigation-trigger">
					<span style={{color: color}}>{title}</span>
					<Icon name="arrow-right" width={12} height={12} />
				</Button>
				:
				<FlatNavigationLink
					classNames={cn('d-flex dc-lg-none-not-equal nav-link', {'nav-link-editorial': isEditorialItem})}
					title={title}
					description={description}
					url={url}
					color={color}
					navigationParams={navigationParams}
					queryParameters={queryParameters}
					image={isEditorialItem ? image : undefined}
				/>
			}
		</li>
	);
};

export default FlatNavigationItemContent;
